import type { ProjectRackState } from "../projects/project-types";
import type {
  CargoEditorCargoAsset,
  CargoEditorRackCargoUpdate
} from "../scenes/cargo-editor-scene";

type CargoContents = Record<string, CargoEditorCargoAsset>;

export function replaceRackCargoContents(
  contents: CargoContents,
  rackId: string,
  updates: CargoEditorRackCargoUpdate[]
) {
  const next = Object.fromEntries(
    Object.entries(contents).filter(([key]) => key.split("\u0000", 1)[0] !== rackId)
  ) as CargoContents;

  updates.forEach(({ asset, cellId, heightIndex, slotIndex }) => {
    if (asset) {
      next[[rackId, cellId, heightIndex, slotIndex].join("\u0000")] = asset;
    }
  });
  return next;
}

export function createProjectRackCargo(updates: CargoEditorRackCargoUpdate[]) {
  return Object.fromEntries(
    updates.map(({ asset, cellId, heightIndex, slotIndex }) => [
      [cellId, heightIndex, slotIndex].join("\u0000"),
      asset ?? null
    ])
  ) as ProjectRackState["cargo"];
}
